(function () {
  if (window.tnhHome) return;
  window.tnhHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tabs: body-area chooser and customer stories. Tabs are links/buttons, panels toggle with [hidden].
  function initTabs(root) {
    if (root.dataset.tnhReady) return;
    root.dataset.tnhReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tnh-tab]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      var p = panels[i];
      if (p) {
        if (!reduce) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
        p.querySelectorAll('[data-tnh-ba]').forEach(initBA);
      }
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); select(i); });
      t.addEventListener('keydown', function (e) {
        var n = null, last = tabs.length - 1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = i === 0 ? last : i - 1;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = last;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
  }

  // Before/after slider. A native range input drives --pos; a one-off nudge shows it can be dragged.
  function initBA(fig) {
    if (fig.dataset.tnhReady || fig.closest('[hidden]')) return;
    fig.dataset.tnhReady = '1';
    var input = fig.querySelector('input');
    function set(v) { fig.style.setProperty('--pos', v + '%'); }
    function touched() { fig.dataset.touched = '1'; }
    input.addEventListener('input', function () { touched(); set(input.value); });
    input.addEventListener('pointerdown', touched);
    input.addEventListener('keydown', touched);
    set(input.value);
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var pts = [50, 34, 64, 50], dur = [520, 760, 520], seg = 0, start = null;
      function ease(t) { return 1 - Math.pow(1 - t, 3); }
      function step(ts) {
        if (fig.dataset.touched) return;
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / dur[seg]);
        var v = pts[seg] + (pts[seg + 1] - pts[seg]) * ease(t);
        set(v.toFixed(2));
        input.value = v;
        if (t === 1) { seg++; start = null; if (seg >= dur.length) return; }
        requestAnimationFrame(step);
      }
      setTimeout(function () { requestAnimationFrame(step); }, 300);
    }, { threshold: 0.55 });
    io.observe(fig);
  }

  // The currency app appends an ISO code ("$24.00 USD"). Kate never wants it shown, so strip it from our prices,
  // including after the app re-converts them.
  var CODE = /\s*\b[A-Z]{3}\b\s*$/;
  function stripCode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = walker.nextNode())) {
      if (CODE.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(CODE, '');
    }
  }
  function initMoney(el) {
    if (el.dataset.tnhMoneyReady) return;
    el.dataset.tnhMoneyReady = '1';
    stripCode(el);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      stripCode(el);
      var up = el.closest('.tnh-up');
      if (up && el.hasAttribute('data-tnh-unit')) updateUpsell(up);
      if (el.hasAttribute('data-tnh-price-unit') || el.hasAttribute('data-tnh-price-unitwas')) updateProduct(el.closest('.tnh-panel'));
    }).observe(el, { childList: true, subtree: true, characterData: true });
  }

  // Money helpers that copy the format of a price already on the page (symbol, separators, decimals),
  // so totals stay in the shopper's currency after the currency app converts the unit price.
  function moneyParts(sample) {
    var m = sample.match(/\d[\d.,\s ]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var dm = raw.match(/[.,](\d{2})$/);
    var dec = dm ? dm[0].charAt(0) : '';
    var intPart = dm ? raw.slice(0, -3) : raw;
    var thou = (intPart.match(/[.,\s ]/) || [dec === ',' ? '.' : ','])[0];
    var value = parseFloat(intPart.replace(/[^\d]/g, '') + (dm ? '.' + dm[1] : ''));
    return { raw: raw, index: m.index, dec: dec, thou: thou, decimals: dm ? 2 : 0, value: value };
  }
  function formatLike(sample, parts, value) {
    var fixed = value.toFixed(parts.decimals).split('.');
    var out = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, parts.thou) + (parts.decimals ? parts.dec + fixed[1] : '');
    return sample.slice(0, parts.index) + out + sample.slice(parts.index + parts.raw.length);
  }
  function tierPct(el, qty) {
    var tiers = [], pct = 0;
    try { tiers = JSON.parse(el.getAttribute('data-tnh-tiers') || '[]'); } catch (err) {}
    tiers.forEach(function (t) { if (qty >= t.min && t.pct > pct) pct = t.pct; });
    return pct;
  }

  // Add-on price: unit price x quantity, less the volume tier the discount app applies for that quantity.
  function updateUpsell(up) {
    var unitEl = up.querySelector('[data-tnh-unit]');
    var nowEl = up.querySelector('[data-tnh-up-now]');
    var wasEl = up.querySelector('[data-tnh-up-was]');
    var qtyEl = up.querySelector('[data-tnh-qty-val]');
    if (!unitEl || !nowEl || !qtyEl) return;
    var sample = unitEl.textContent.trim();
    var parts = moneyParts(sample);
    if (!parts || !isFinite(parts.value)) return;
    var qty = Math.max(1, parseInt(qtyEl.textContent, 10) || 1);
    var pct = tierPct(up, qty);
    var full = Math.round(parts.value * qty * 100) / 100;
    var now = Math.round(full * (100 - pct)) / 100;
    nowEl.textContent = formatLike(sample, parts, now);
    if (wasEl) {
      wasEl.hidden = pct === 0;
      wasEl.textContent = pct ? formatLike(sample, parts, full) : '';
    }
  }

  // Product price in the chooser, matching the multi-pack offer on the product pages (the store's automatic
  // discounts apply the same percentages in the cart). 1 pack: price, crossed-out compare price. 2+ packs: the
  // discounted total, crossed out against the full price for that many packs. The SAVE pill shows the real saving.
  function updateProduct(panel) {
    if (!panel) return;
    var qtyEl = panel.querySelector('[data-tnh-buybox]:not(.tnh-up) [data-tnh-qty-val]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.textContent, 10) || 1) : 1;
    var unitEl = panel.querySelector('[data-tnh-price-unit]');
    var nowEl = panel.querySelector('[data-tnh-price-now]');
    if (!unitEl || !nowEl) return;
    var sample = unitEl.textContent.trim();
    var parts = moneyParts(sample);
    if (!parts || !isFinite(parts.value)) return;
    var wasUnitEl = panel.querySelector('[data-tnh-price-unitwas]');
    var wasEl = panel.querySelector('[data-tnh-price-was]');
    var saveEl = panel.querySelector('.tnh-save');
    var pct = tierPct(panel, qty);
    var full = Math.round(parts.value * qty * 100) / 100;
    var now = Math.round(full * (100 - pct)) / 100;
    var was = full;
    if (pct === 0 && wasUnitEl) {
      var wp = moneyParts(wasUnitEl.textContent.trim());
      if (wp && isFinite(wp.value)) was = Math.round(wp.value * qty * 100) / 100;
    }
    nowEl.textContent = formatLike(sample, parts, now);
    if (wasEl) { wasEl.textContent = formatLike(sample, parts, was); wasEl.hidden = was <= now; }
    if (saveEl && was > now) saveEl.textContent = 'SAVE ' + Math.round((1 - now / was) * 100) + '%';
  }

  // Tap-to-play videos: nothing downloads until a video is tapped; only one plays at a time.
  function onReel(e) {
    var box = e.target.closest('[data-tnh-reel]');
    if (!box) return;
    var video = box.querySelector('video');
    if (!video) return;
    var card = box.closest('.tnh-reel');
    if (!video.paused) { video.pause(); return; }
    document.querySelectorAll('[data-tnh-reel] video').forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
    video.setAttribute('preload', 'auto');
    if (!video.dataset.tnhBound) {
      video.dataset.tnhBound = '1';
      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Quantity steppers (1–10), for the product and the add-on.
  function onQty(e) {
    var q = e.target.closest('[data-tnh-qty]');
    if (!q) return;
    var box = q.closest('[data-tnh-buybox]');
    var val = box && box.querySelector('[data-tnh-qty-val]');
    if (!val) return;
    var n = (parseInt(val.textContent, 10) || 1) + Number(q.getAttribute('data-tnh-qty'));
    val.textContent = Math.max(1, Math.min(10, n));
    if (box.classList.contains('tnh-up')) updateUpsell(box);
    else updateProduct(box.closest('.tnh-panel'));
  }

  // Quick add. Goes through window.fetch so the cart drawer's watcher re-renders and opens the drawer.
  function onAdd(e) {
    var b = e.target.closest('[data-tnh-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var label = b.querySelector('[data-tnh-label]') || b;
    var orig = label.textContent;
    var box = b.closest('[data-tnh-buybox]');
    var msg = box && box.querySelector('[data-tnh-msg]');
    var qtyEl = box && box.querySelector('[data-tnh-qty-val]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.textContent, 10) || 1) : 1;
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    label.textContent = b.getAttribute('data-busy') || 'Adding…';
    if (msg) msg.textContent = '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-tnh-add')), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ''); return j; });
    }).then(function () {
      label.textContent = b.getAttribute('data-done') || 'Added';
      b.classList.add('is-done');
      if (qtyEl) {
        qtyEl.textContent = '1';
        if (box.classList.contains('tnh-up')) updateUpsell(box);
        else updateProduct(box.closest('.tnh-panel'));
      }
      setTimeout(function () { label.textContent = orig; b.classList.remove('is-done'); }, 1800);
    }).catch(function (err) {
      label.textContent = orig;
      if (msg) msg.textContent = (err && err.message) || "We couldn't add that to your cart. Please try again.";
    }).then(function () {
      b.disabled = false;
      b.removeAttribute('aria-busy');
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-tnh-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-tnh-ba]').forEach(initBA);
    scope.querySelectorAll('[data-tnh-money]').forEach(initMoney);
    scope.querySelectorAll('.tnh-up').forEach(updateUpsell);
    scope.querySelectorAll('.tnh-panel').forEach(updateProduct);
  }
  document.addEventListener('click', onReel);
  document.addEventListener('click', onQty);
  document.addEventListener('click', onAdd);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();